import { t as tr } from '@hana/i18n';
import './ReqAdvPad.i18n';
import { IconArrowBackUp, IconCheck, IconLock } from '@tabler/icons-react';
import { useList } from '@hana/data';
import { Button, useToast } from '@hana/ui';
import type { Advance, Voucher } from './types';
import { stepChips } from './requests';
import { f1 } from './view';
import s from './reqAdvPad.module.css';

// Mint-Cost-iPad › tab Đề nghị TT (thẻ 2 cột) + tab Tạm ứng (một thẻ, mỗi người một dòng). Chỉ đọc; nút ghi báo toast.

const ME = 'LIENNTK';
const ACC = '[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP';
const PAY_TIP = { BNK: 'Người trả BNK · Công ty trả', EMP: 'Người trả EMP · Nhân viên trả' } as const;
const WAIT: Record<string, string> = {
  c1: 'Created · chờ cấp 1 [OPS-MGR] PHONGNT',
  kt: 'Confirmed · chờ bạn [ACC-CP]',
  gd: `Confirmed · chờ ${ACC}`,
  done: 'Approved · chờ vào đợt chi',
  rq: 'RQ Payment · trong đợt chi',
  paid: 'Payment Done',
  back: 'Need Revise · người lập đang sửa',
};

export function ReqPad({ vouchers, q }: { vouchers: readonly Voucher[]; q: string }) {
  const toast = useToast();
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });
  const needle = q.trim().toLowerCase();
  const shown = vouchers.filter((v) => !needle || `${v.no} ${v.partner} ${v.job} ${v.maker}`.toLowerCase().includes(needle));
  return (
    <>
      <div className={s.acc}>Duyệt chi vượt ngưỡng: {ACC} · thẩm quyền PAYMENT-APPROVE</div>
      <div className={s.grid}>
        {shown.map((v) => {
          const own = v.maker === ME;
          const mine = v.status === 'kt' && !own;
          return (
            <section key={v.no} className={s.card} aria-label={`Đề nghị ${v.no}`}>
              <div className={s.top}>
                <b className={s.no}>{v.no}</b>
                <b className={s.amt}>{f1(v.total)} tr</b>
              </div>
              <div className={s.ncc}>
                <span className={s.ell}>
                  {v.maker} · {v.partner} · {v.job}
                </span>
                <span className={`${s.pay} ${s[`pay_${v.payer}`]}`} title={PAY_TIP[v.payer]} aria-label={PAY_TIP[v.payer]}>
                  {v.payer}
                </span>
              </div>
              <div className={s.sub}>
                BIL {f1(v.withInvoice)} · ABS {f1(v.noInvoice)} · OBH {f1(v.onBehalf)}
              </div>
              <div className={s.chips}>
                {stepChips(v).map((p) => (
                  <span key={p.key} className={`${s.step} ${s[`step_${p.tone}`]}`} title={p.tip}>
                    {p.label}
                  </span>
                ))}
              </div>
              {mine ? (
                <div className={s.row}>
                  <Button variant="primary" icon={<IconCheck size={16} aria-hidden="true" />} onClick={noWrite}>
                    {tr('rqa.1')}
                  </Button>
                  <Button icon={<IconArrowBackUp size={16} aria-hidden="true" />} onClick={noWrite}>
                    {tr('rqa.2')}
                  </Button>
                </div>
              ) : (
                <span className={s.sub}>{own && v.status === 'kt' ? `Bạn là người lập — bước kế toán đẩy lên ${ACC}` : WAIT[v.status]}</span>
              )}
            </section>
          );
        })}
      </div>
    </>
  );
}

const ST = { open: 'Đang mở', over: 'Chặn ứng mới', done: 'Đã quyết toán' } as const;

export function AdvPad({ q }: { q: string }) {
  const toast = useToast();
  const rows = (useList('finAdvance', { limit: 500 }).data?.items ?? []) as readonly Advance[];
  const needle = q.trim().toLowerCase();
  const shown = rows.filter((a) => !needle || `${a.who} ${a.ref} ${a.what}`.toLowerCase().includes(needle));
  return (
    <>
      <div className={s.end}>
        <Button icon={<IconLock size={16} aria-hidden="true" />} onClick={() => toast({ msg: 'Quyết toán theo người chưa mở ở bản này' })}>
          {tr('rqa.3')}
        </Button>
      </div>
      <section className={s.list} aria-label="Tạm ứng">
        {shown.map((a) => (
          <div key={a.ref} className={s.adv}>
            <div className={s.grow}>
              <b className={s.who}>{a.who}</b> <span className={s.sub}>{a.ref} · {a.what}</span>
              <div className={`${s.sub} ${a.status === 'over' ? s.err : ''}`}>{a.due}</div>
            </div>
            <span className={s.nw}>
              {tr('rqa.4')} <b className={s.who}>{f1(a.held)}</b> / {f1(a.amount)} tr
            </span>
            <span className={`${s.pill} ${s[`p_${a.status}`]}`}>{ST[a.status]}</span>
          </div>
        ))}
      </section>
    </>
  );
}
